import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, StrokePath } from "./shared";

export function IconPartialDenture(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(0 -5.4)">
        <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
      <StrokePath d="M2.8 12.2c-1 0-1.6-.8-1.6-1.8M21.2 12.2c1 0 1.6-.8 1.6-1.8" />
    </ClinicalIconSvg>
  );
}

export function IconCompleteDenture(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M0.8 6.8v-3.5A1.5 1.5 0 0 1 1.8 1.8C3.2 1.4 6.2 0.8 12 0.8s8.8 0.6 10.2 1.1a1.5 1.5 0 0 1 1.0 1.4v3.5" />
      <StrokePath d="M5.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M9.8 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M14.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M18.8 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M23.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
      <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
    </ClinicalIconSvg>
  );
}

export function IconToothAddition(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(0 -5.4)">
        <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
        <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
      <StrokePath d="M19.4 2.6v4.4M17.2 4.8h4.4" />
    </ClinicalIconSvg>
  );
}

export function IconDentureRepair(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(5.4 5) scale(.55)">
        <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
        <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      </g>
      <StrokePath d="M18 4.3A9.8 9.8 0 0 0 2.3 12v2.3M6 19.7A9.8 9.8 0 0 0 21.8 12V9.8m-21 .8 1.5 1.5 1.5-1.5m18.5-1.5-1.5-1.5-1.5 1.5" />
    </ClinicalIconSvg>
  );
}
